export const FARM_ICON_META = {
  hay: {
    label: "Field Work",
    emoji: "🌾",
    color: "#2f855a",
    bg: "#eef7ed",
  },
  grass: {
    label: "Grass Cutting",
    emoji: "🚜",
    color: "#f59e0b",
    bg: "#fff7ed",
  },
  grain: {
    label: "Grain / Crop",
    emoji: "🌽",
    color: "#b7791f",
    bg: "#fff8e6",
  },
  dayJob: {
    label: "Day Job",
    emoji: "🛠",
    color: "#7c3aed",
    bg: "#f3e8ff",
  },
  livestock: {
    label: "Livestock",
    emoji: "🐄",
    color: "#dc2626",
    bg: "#fee2e2",
  },
  event: {
    label: "Event",
    emoji: "📅",
    color: "#3b82f6",
    bg: "#dbeafe",
  },
  product: {
    label: "Product",
    emoji: "🛒",
    color: "#16a34a",
    bg: "#dcfce7",
  },
  farmStand: {
    label: "Farm Stand",
    emoji: "🥕",
    color: "#15803d",
    bg: "#dcfce7",
  },
  pickupSpot: {
    label: "Pickup Spot",
    emoji: "📦",
    color: "#0f766e",
    bg: "#ccfbf1",
  },
  equipment: {
    label: "Equipment",
    emoji: "🚜",
    color: "#374151",
    bg: "#f3f4f6",
  },
  landUse: {
    label: "Land Share",
    emoji: "🧭",
    color: "#2f855a",
    bg: "#eef6ec",
  },
  default: {
    label: "Listing",
    emoji: "📍",
    color: "#2f855a",
    bg: "#eef7ed",
  },
};

export const getFarmIconMeta = (type) => {
  const key = String(type || "").toLowerCase();

  if (key.includes("day") || key.includes("labor") || key.includes("fenc")) {
    return FARM_ICON_META.dayJob;
  }

  if (key.includes("event") || key.includes("fair") || key.includes("market")) {
    return FARM_ICON_META.event;
  }

  if (key.includes("livestock") || key.includes("cattle") || key.includes("animal")) {
    return FARM_ICON_META.livestock;
  }

  if (key.includes("product") || key.includes("sale") || key.includes("eggs")) {
    return FARM_ICON_META.product;
  }

  if (key.includes("pickup")) {
    return FARM_ICON_META.pickupSpot;
  }

  if (key.includes("farm_stand") || key.includes("stand")) {
    return FARM_ICON_META.farmStand;
  }

  if (key.includes("equipment") || key.includes("tractor")) {
    return FARM_ICON_META.equipment;
  }

  if (key.includes("land_use") || key.includes("pasture") || key.includes("grazing")) {
    return FARM_ICON_META.landUse;
  }

  if (key.includes("grain") || key.includes("corn")) {
    return FARM_ICON_META.grain;
  }

  if (key.includes("grass") || key.includes("mow")) {
    return FARM_ICON_META.grass;
  }

  if (key.includes("hay") || key.includes("field") || key.includes("bermuda")) {
    return FARM_ICON_META.hay;
  }

  return FARM_ICON_META.default;
};

export const createFarmMapIcon = (type, isActive = false) => {
  const meta = getFarmIconMeta(type);

  const size = isActive ? 50 : 42;
  const radius = isActive ? 20 : 18;

  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
      <defs>
        <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="3" stdDeviation="3" flood-color="rgba(0,0,0,0.28)"/>
        </filter>
      </defs>

      ${
        isActive
          ? `<circle cx="${size / 2}" cy="${size / 2}" r="${radius + 3}" fill="rgba(255,255,255,0.92)" />`
          : ""
      }

      <circle
        cx="${size / 2}"
        cy="${size / 2}"
        r="${radius}"
        fill="${meta.color}"
        filter="url(#shadow)"
      />

      <text
        x="50%"
        y="55%"
        text-anchor="middle"
        font-size="${isActive ? 20 : 18}"
        dominant-baseline="middle"
      >
        ${meta.emoji}
      </text>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};
